import React from 'react';
import type { FollowButtonSize } from '../constants/styles';
import styles from './FollowLoadingButton.module.scss';

export interface FollowLoadingButtonProps {
    size?: FollowButtonSize;
}

/**
 * Skeleton shimmer shown while follow-state is loading (`isFollowing` not yet a
 * boolean). Ported from eb-ui `FollowLoadingButton.jsx` + `.scss` → CSS Module.
 */
const FollowLoadingButton = ({ size = 'standard' }: FollowLoadingButtonProps) => (
    <div className={styles['loading-button__container']}>
        <div
            className={`${styles['loading-button']} ${
                styles[`loading-button--${size}`] ?? ''
            }`}
        >
            <div className={styles['loading-button__main']} />
        </div>
    </div>
);

export default FollowLoadingButton;
